import './message-display.css';

/*
 * Component responsible for /message-display route.
 */
angular.module('posApp').directive('messageDisplay', (mask) => ({
  restrict: 'E',

  scope: true,

  template: require('./message-display.html').default,

  link: function ($scope) {
    $scope.mask = mask;
  },
}));
